import HeaderBar from './header-bar.vue'
export default HeaderBar
